import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'rc-time-picker/assets/index.css';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import TimePicker from 'rc-time-picker';
import { Icon } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';
import cm from 'helpers/commons';
class Time extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      now: null
    };
  }

  componentWillMount() {
    const { defVal } = this.props;
    console.log('componentWillMount');
    let now = defVal ? moment(new Date(defVal)) : moment(new Date());
    if (defVal !== 'not default value') this.onChange(now);
    if (defVal === 'cleanData') this.cleanData();
    // if (isNaN(now)) this.onChange(now);
  }

  cleanData = () => {
    const { commonFn, timeType, placeholder } = this.props;
      commonFn.changeTime({
        type: 'time',
        name: timeType,
        value: null
      });
      this.setState({ now: null });
  };

  onChange = (value) => {
    const { commonFn, timeType, placeholder } = this.props;
    if (value) {
      const remainder = value.minute();
      if (remainder % 5 !== 0) {
        value.minute(0);
      }
      commonFn.changeTime({
        type: 'time',
        name: timeType,
        value: value.format(placeholder ? placeholder : 'LL')
      });
      this.setState({ now: value });
    }
    this.setState({ open: false });
  };

  disabledMinutes = () => {
    const data = [];
    for (let i = 0; i < 60; i++) {
      if (i % 5 !== 0) {
        data.push(i);
      }
    }
    return data;
  };

  open = () => {
    this.setState({ open: true });
  };

  render() {
    const { now } = this.state;
    const { isDim, timeType, cName, isShowMinute, isShowSecond, defVal, placeholder, isHide, value } = this.props;
    const format = placeholder ? placeholder : 'HH:mm';
    return !isHide ? (
      <Icon.Group className={isDim ? 'cm-time dim' : 'cm-time'}>
        <Icon bordered name="wait" />
        <TimePicker
          showMinute={isShowMinute}
          showSecond={isShowSecond}
          disabledMinutes={this.disabledMinutes}
          onOpen={this.open}
          // defaultValue={now}
          value={now}
          placeholder={format}
          onChange={(e) => this.onChange(e)}
          disabled={isDim}
          dateFormat="HH-mm"
          className={timeType}
          hideDisabledOptions={true}
          // open={this.state.open}
          popupClassName={cName}
        />
      </Icon.Group>
    ) : null;
  }
}

Time = connect(
  (state) => ({
    time: state.commons.time
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeTime: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(Time);

export default Time;
